import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ToastController, ViewController, AlertController, LoadingController, ActionSheetController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup, AbstractControl } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Storage } from '@ionic/storage';
import { BusinessProductCategoryManagerHandler } from '../../providers/business-product-category-handler';
import { BusinessProductSubcategoryManagerPage } from '../business-product-subcategory-manager/business-product-subcategory-manager';
import { Globals } from '../../providers/globals';

@Component({
  selector: 'page-business-product-category-manager',
  templateUrl: 'business-product-category-manager.html',
})
export class BusinessProductCategoryManagerPage {
	category: any;
	subcategories: any = [];
	private form : FormGroup;
	loader: any;
	filePath: any;
	isLoading: boolean = false;
	saveIsLoading: boolean = false;
	deleteIsLoading: boolean = false;

  	constructor(  		
  		private toastCtrl: ToastController,
		public navCtrl: NavController, 
		public viewCtrl: ViewController,
		public navParams: NavParams,
		private formBuilder: FormBuilder,
		public managerHandler: BusinessProductCategoryManagerHandler,
		public storage: Storage,
		public loadingCtrl: LoadingController,
		public alertCtrl: AlertController,
		public globals: Globals,
		public actionSheetCtrl: ActionSheetController,
		public _DomSanitizer: DomSanitizer
		) {

  		this.category = navParams.get('category');
		
	    this.form = this.formBuilder.group({
	    	"Id": [''],
		  	"CategoryName":  ['', Validators.required],
		    "IsActive": [true],
	   	});   
  	}

  	ionViewWillEnter() {
		if(this.category.Id){
	   		this.load(this.category.Id);
	    } 
	}

	load(id){
		this.isLoading = true;

		this.managerHandler.getProductCategory(id, (result)=>{
		  	
		  	if(result.category.Id != ''){
		  		this.category = result.category;

		  		this.form.patchValue(
					this.category
		    	)

		    	this.subcategories = result.subCategories;
		  	}

		  	this.isLoading = false;
		})
	}

	delete(){
		this.deleteIsLoading = true;
		
		this.managerHandler.delete(this.category.Id, (result)=>{
			this.deleteIsLoading = true;

			if(result.Success)
				this.navCtrl.pop();
			else{
				let alert = this.alertCtrl.create({
	              title: 'Error',
	              subTitle: result.Message,
	              buttons: ['Ok']
	            });

	            alert.present();
			}
		});			
	}

	presentDeleteConfirmation() {
	  let alert = this.alertCtrl.create({
	    title: 'Confirm deletion',
	    message: 'Do you want to delete this category?',
	    buttons: [
	      {
	        text: 'Delete',
	        handler: () => {
	          console.log('Delete clicked');
	          this.delete()
	        }
	      },
	      {
	        text: 'Cancel',
	        role: 'cancel',
	        handler: () => {
	          console.log('Cancel clicked');
	        }
	      }
	    ]
	  });
	  alert.present();
	}

	onSubmit(){
		if(this.saveIsLoading)
			return

		this.saveIsLoading = true;

		if(this.form.value.Id != ''){

			console.log("entered update");

			this.managerHandler.update(this.form.value.Id, this.form.value, (result)=>{
				if(result.Success){
					let toast = this.toastCtrl.create({
						message: 'Category has been updated',
						duration: 3000,
						position: 'bottom'
					});

					this.category.CategoryName = this.form.value.CategoryName;

					toast.present();						
				} else {
					let alert = this.alertCtrl.create({
				    	title: 'Error',
				    	subTitle: result.Message,
				    	buttons: ['Ok']
				  	});
				  	
				  	alert.present();
				}

				this.saveIsLoading = false;
			})

		} else {
			console.log("entered create");

			this.managerHandler.create(this.form.value, (result)=>{
				if(result.Success){
					this.load(result.Data.Id);
				} else {
					let alert = this.alertCtrl.create({
				    	title: 'Error',
				    	subTitle: result.Message,
				    	buttons: ['Ok']
				  	});
				  	
				  	alert.present();
				}
			  				  	
				this.saveIsLoading = false;
			})
		}		  	
	}

	create(){
	    this.navCtrl.push(BusinessProductSubcategoryManagerPage, {
	      subcategory: {},
	      category: this.category
	    });		
	}

	manage($e, subcategory){
	    this.navCtrl.push(BusinessProductSubcategoryManagerPage, {
	      subcategory: subcategory,
	      category: this.category
	    });				
	}
}


// WEBPACK FOOTER //
// ./src/pages/business-product-category-manager/business-product-category-manager.ts